import { useTranslation } from 'react-i18next';
import { Flex, PageContainer } from '@/components';
import { WalletPageContextProvider } from './WalletPageContext';

import WalletPageContent from './WalletPageContent';

export function WalletPage() {
  const { t } = useTranslation(['common', 'payment']);
  return (
    <PageContainer title={t('common:labels.wallet')}>
      <Flex className="mx-auto min-h-full w-full min-w-0 max-w-full overflow-x-hidden">
        <WalletPageContextProvider>
          <WalletPageContent />
        </WalletPageContextProvider>
      </Flex>
    </PageContainer>
  );
}

export default WalletPage;
